import enAgentDashboardPage from './agentDashboard';
import enBackendMessages from './backendMessage';
import enComponents from './components';
import enMessages from './messages';
import enPages from './page';

const enLanguage = {
  ...enMessages,
  ...enPages,
  ...enBackendMessages,
  ...enAgentDashboardPage,
  ...enComponents,
  'base.UpdateSuccess': 'Update success',
  'base.Email': 'Email',
  'base.Password': 'Password',
  'base.NewPassword': 'New password',
  'base.ConfirmPassword': 'Confirm Password',
  'base.SignIn': 'Sign In',
  'base.Error': 'Error',
  'base.Login': 'Login',
  'base.Logout': 'Logout',
  'base.Register': 'Register',
  'base.BackLoginPage': 'Back to login page',
  'base.Submit': 'Submit',
  'base.FirstName': 'First and middle name',
  'base.LastName': 'Last name',
  'base.PhoneNumber': 'Phone number',
  'base.Title': 'Title',
  'base.Ms': 'Ms',
  'base.Mr': 'Mr',
  'base.Close': 'Close',
  'base.Save': 'Save',
  'base.MyProfile': 'My Profile',
  'base.SignUp': 'Sign up',
  'base.Address': 'Address',
  'base.Country': 'Country',
  'base.CityName': 'City name',
  'base.FaxNumber': 'Fax number',
  'base.PostalCode': 'Postal code',
  'base.Yes': 'Yes',
  'base.No': 'No',
  'base.Download': 'Download',
  'base.Remove': 'Remove',
  'base.Update': 'Update',
  'base.Edit': 'Edit',
  'base.Active': 'Active',
  'base.UserName': 'Username',
  'base.Search': 'Search',
  'base.Reset': 'Reset',
  'base.FullName': 'Full Name',
  'base.Roles': 'Roles',
  'base.Confirm': 'Confirm',
  'base.Cancel': 'Cancel',
  'base.Action': 'Action',
};

export default enLanguage;
